import React from 'react';
import { BarChart3 } from 'lucide-react';

const UsageHistoryChart = ({ usageData }) => {
  // Mock historical data for visualization (in real app, this would come from backend)
  const historicalData = [
    { month: 'Jan', exports: 2, caregivers: 0 },
    { month: 'Feb', exports: 1, caregivers: 0 },
    { month: 'Mar', exports: 2, caregivers: 0 },
    { month: 'Apr', exports: 2, caregivers: 0 },
    { month: 'May', exports: usageData?.monthlyExports?.usageCount || 0, caregivers: 0 }
  ];

  const maxValue = Math.max(...historicalData?.map(d => Math.max(d?.exports, d?.caregivers)), 5);

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <BarChart3 className="w-6 h-6 text-blue-600" />
          <div>
            <h2 className="text-xl font-bold text-gray-900">Usage History</h2>
            <p className="text-sm text-gray-600">Your feature usage over the last 5 months</p>
          </div>
        </div>
      </div>

      {/* Chart */}
      <div className="space-y-6">
        {/* Exports Chart */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-3">Monthly Exports</h3>
          <div className="flex items-end space-x-2 h-40">
            {historicalData?.map((data, index) => (
              <div key={index} className="flex-1 flex flex-col items-center">
                <div className="w-full flex flex-col justify-end h-32 mb-2">
                  <div
                    className="w-full bg-blue-600 rounded-t transition-all hover:bg-blue-700"
                    style={{ height: `${(data?.exports / maxValue) * 100}%` }}
                  >
                    {data?.exports > 0 && (
                      <div className="text-white text-xs font-semibold text-center pt-1">
                        {data?.exports}
                      </div>
                    )}
                  </div>
                </div>
                <span className="text-xs text-gray-600 font-medium">{data?.month}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Legend */}
        <div className="flex items-center justify-center space-x-6 pt-4 border-t border-gray-200">
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-blue-600 rounded"></div>
            <span className="text-sm text-gray-600">Exports Used</span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-gray-300 rounded"></div>
            <span className="text-sm text-gray-600">Limit: 2/month</span>
          </div>
        </div>
      </div>

      {/* Insights */}
      <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h4 className="font-semibold text-gray-900 mb-2">Usage Insights</h4>
        <ul className="space-y-1 text-sm text-gray-700">
          <li>• You consistently use your export allowance each month</li>
          <li>• Consider upgrading for unlimited exports</li>
          <li>• Premium users export an average of 8 times per month</li>
        </ul>
      </div>
    </div>
  );
};

export default UsageHistoryChart;